export default __webpack_public_path__ + "static/media/8W3A2042_tn.fd399a59.jpg";